import React, { useEffect, useState } from "react";
import URI from "urijs";
import { v4 as uuid } from "uuid";
import { Spinner } from "components/common";
import connect from "stores/connect";
import Store from "logic/local-storage/Store";
import OidcRoutes from "authentication/components/oidc/Routes";
import OidcLoginForm from "./OidcLoginForm";
import OidcCallback from "./OidcCallback";
import { OidcConfigurationStore } from "./OidcConfigurationStore";
import { OidcSessionStore } from "./OidcSessionStore";
const OidcLogin = ({ configuration = void 0, isLoading, onErrorChange }) => {
  const uri = new URI(window.location.href);
  const isCallbackUrl = () => uri.path() === OidcRoutes.AUTH_CALLBACK;
  const generateNonce = (redirectTo = uri.resource()) => ({
    state: uuid(),
    redirectTo
  });
  const [nonce, setNonce] = useState(() => {
    var _a;
    try {
      if (isCallbackUrl()) {
        return (_a = Store.sessionGet("nonce")) != null ? _a : generateNonce();
      }
    } catch (_e) {
      return generateNonce();
    }
    return generateNonce();
  });
  const regenerateNonce = () => {
    setNonce((prevNonce) => generateNonce(prevNonce.redirectTo));
  };
  useEffect(() => {
    Store.sessionSet("nonce", nonce);
  }, [nonce]);
  if (isLoading || !configuration) {
    return /* @__PURE__ */ React.createElement("p", { className: "loading-text" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading, please wait...", delay: 0 }));
  }
  if (isCallbackUrl()) {
    return /* @__PURE__ */ React.createElement(
      OidcCallback,
      {
        configuration,
        nonce,
        onErrorChange,
        params: uri.query(true),
        regenerateNonce
      }
    );
  }
  return /* @__PURE__ */ React.createElement(OidcLoginForm, { checkSession: true, configuration, nonce });
};
export default connect(
  OidcLogin,
  {
    configuration: OidcConfigurationStore,
    oidcSession: OidcSessionStore
  },
  ({ configuration, oidcSession, ...props }) => ({
    ...props,
    configuration: configuration.configuration,
    isLoading: oidcSession.isLoading
  })
);
